(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 5557:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(3678);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 4318:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ImageGliph; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_future_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1608);
/* harmony import */ var next_future_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_future_image__WEBPACK_IMPORTED_MODULE_1__);


function ImageGliph(param) {
    var src = param.src;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        className: "glyph-image-container",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_future_image__WEBPACK_IMPORTED_MODULE_1___default()), {
            layout: "raw",
            width: "200",
            height: "200",
            src: "/assets/animated-glyphs/".concat(src, ".gif")
        })
    });
}


/***/ }),

/***/ 2142:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);



var ImageWithTransition = function(param) {
    var src = param.src, layout = param.layout, sizes = param.sizes, _alt = param.alt, alt = _alt === void 0 ? "" : _alt, classes = param.classes, objectFit = param.objectFit, _loading = param.loading, loading = _loading === void 0 ? "lazy" : _loading, _priority = param.priority, priority = _priority === void 0 ? false : _priority, _quality = param.quality, quality = _quality === void 0 ? 75 : _quality;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true), isLoading = ref[0], setIsLoading = ref[1];
    var onLoadingComplete = function() {
        return setIsLoading(false);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
        className: "".concat(classes, " transition-all duration-500 ").concat(isLoading ? "opacity-0" : "opacity-100"),
        src: src,
        layout: layout,
        onLoadingComplete: onLoadingComplete,
        objectFit: objectFit,
        priority: priority,
        quality: quality,
        loading: loading,
        alt: alt,
        sizes: sizes
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ImageWithTransition);


/***/ }),

/***/ 6980:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "e": function() { return /* binding */ NewsCard; },
  "t": function() { return /* binding */ ProjectCard; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react-fast-marquee/dist/index.js
var dist = __webpack_require__(7005);
// EXTERNAL MODULE: ./components/Elements/ImageWithTransition.js
var ImageWithTransition = __webpack_require__(2142);
// EXTERNAL MODULE: ./node_modules/bowser/es5.js
var es5 = __webpack_require__(1206);
var es5_default = /*#__PURE__*/__webpack_require__.n(es5);
;// CONCATENATED MODULE: ./components/Elements/VideoLazy.js



function VideoLazy(param) {
    var videoDesktop = param.videoDesktop, videoMobile = param.videoMobile;
    var ref = (0,react.useState)(null), platform = ref[0], setPlatform = ref[1];
    (0,react.useEffect)(function() {
        var browser = es5_default().getParser(window.navigator.userAgent);
        setPlatform(browser.getPlatform().type);
    }, []);
    (0,react.useEffect)(function() {
        var lazyVideos = [].slice.call(document.querySelectorAll("video.lazy"));
        if ("IntersectionObserver" in window) {
            var lazyVideoObserver = new IntersectionObserver(function(entries) {
                entries.forEach(function(video) {
                    if (video.isIntersecting) {
                        for(var source in video.target.children){
                            var videoSource = video.target.children[source];
                            if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
                                videoSource.src = videoSource.dataset.src;
                            }
                        }
                        video.target.load();
                        video.target.classList.remove("lazy");
                        lazyVideoObserver.unobserve(video.target);
                    }
                });
            });
            lazyVideos.forEach(function(lazyVideo) {
                lazyVideoObserver.observe(lazyVideo);
            });
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
        preload: "metadata",
        className: "lazy object-center h-full w-full object-cover",
        autoPlay: true,
        muted: true,
        playsInline: true,
        loop: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
            "data-src": platform === "desktop" ? videoDesktop : videoMobile,
            type: "video/mp4"
        })
    });
}

;// CONCATENATED MODULE: ./components/GridCards/index.js






var ProjectCard = function(props) {
    var ref = (0,react.useState)(false), isShown = ref[0], setIsShown = ref[1];
    return props.outsideURL ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "card ".concat(props.size == "Large" ? "1024:col-span-8 col-span-12" : "1024:col-span-4 col-span-12"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
            href: props.outsideURL,
            className: "group",
            onMouseEnter: function() {
                return setIsShown(true);
            },
            onMouseLeave: function() {
                return setIsShown(false);
            },
            target: "_blank",
            rel: "noreferrer",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "relative image-container aspect-video",
                    children: [
                        props.videoDesktop && props.videoMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoLazy, {
                            videoDesktop: props.videoDesktop,
                            videoMobile: props.videoMobile
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageWithTransition/* default */.Z, {
                            src: props.imageUrl,
                            objectFit: "cover",
                            layout: "fill",
                            alt: ""
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "absolute top-0 left-0 w-full h-full transition-opacity duration-300 opacity-0 card-overlay ease-easeInOutQuint group-hover:opacity-100",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "absolute top-0 left-0 w-full h-full overlay-bg bg-black/40"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                    gradient: false,
                                    play: isShown,
                                    speed: 80,
                                    direction: props.index % 2 == 0 ? "left" : "right",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "text-white uppercase",
                                        children: [
                                            props.title ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "inline-block mr-2 align-top fluid-type-medium",
                                                children: props.title
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: "inline-block mr-2 align-top text-18",
                                                children: [
                                                    "view",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "relative -top-0.5 ml-1",
                                                        children: "↗"
                                                    })
                                                ]
                                            }),
                                            props.title ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "inline-block mr-2 align-top fluid-type-medium",
                                                children: props.title
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: "inline-block mr-2 align-top text-18",
                                                children: [
                                                    "view",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "relative -top-0.5 ml-1",
                                                        children: "↗"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "inline-block mr-2 align-top fluid-type-medium",
                                                children: props.title
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: "inline-block mr-2 align-top text-18",
                                                children: [
                                                    "view",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "relative -top-0.5 ml-1",
                                                        children: "↗"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex justify-between gap-x-[20px] mt-2 leading-6 uppercase project-info text-16 768:text-18 1280:text-22",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "w-full",
                            children: [
                                props.title ? /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    children: props.title
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                                props.client ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: props.client
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                            ]
                        }),
                        props.year ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-auto",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: props.year
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "fluid-type-mini flex items-center ml-auto h-[28px] w-[56px] min-w-[56px] 768:h-[32px] 768:w-[70px] 768:min-w-[70px] whitespace-nowrap rounded-[50%] bg-black border-black border-[3px] text-white uppercase overflow-hidden mb-10",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "btn-ticker-inner-v3",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        "data-text": "News",
                                        children: "News"
                                    })
                                })
                            })
                        })
                    ]
                })
            ]
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "card ".concat(props.size == "Large" ? "1024:col-span-8 col-span-12" : "1024:col-span-4 col-span-12"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            prefetch: false,
            scroll: false,
            href: props.projectLink,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                className: "group",
                onMouseEnter: function() {
                    return setIsShown(true);
                },
                onMouseLeave: function() {
                    return setIsShown(false);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative image-container aspect-video",
                        children: [
                            props.videoDesktop && props.videoMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoLazy, {
                                videoDesktop: props.videoDesktop,
                                videoMobile: props.videoMobile
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageWithTransition/* default */.Z, {
                                src: props.imageUrl,
                                objectFit: "cover",
                                layout: "fill",
                                alt: ""
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "absolute top-0 left-0 w-full h-full transition-opacity duration-300 opacity-0 card-overlay ease-easeInOutQuint group-hover:opacity-100",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "absolute top-0 left-0 w-full h-full overlay-bg bg-black/40"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                        gradient: false,
                                        play: isShown,
                                        speed: 80,
                                        direction: props.index % 2 == 0 ? "left" : "right",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            className: "text-white uppercase",
                                            children: [
                                                props.title ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "inline-block mr-2 align-top fluid-type-medium",
                                                    children: props.title
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: "inline-block mr-2 align-top text-18",
                                                    children: [
                                                        "view",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "relative -top-0.5 ml-1",
                                                            children: "↗"
                                                        })
                                                    ]
                                                }),
                                                props.title ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "inline-block mr-2 align-top fluid-type-medium",
                                                    children: props.title
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: "inline-block mr-2 align-top text-18",
                                                    children: [
                                                        "view",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "relative -top-0.5 ml-1",
                                                            children: "↗"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "inline-block mr-2 align-top fluid-type-medium",
                                                    children: props.title
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: "inline-block mr-2 align-top text-18",
                                                    children: [
                                                        "view",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "relative -top-0.5 ml-1",
                                                            children: "↗"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "grid grid-cols-12 gap-0 mt-2 leading-6 uppercase project-info text-16 768:text-18 1280:text-22",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "col-span-8 991:col-span-10",
                                children: [
                                    props.title ? /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        children: props.title
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                                    props.client ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: props.client
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                                ]
                            }),
                            props.year ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-span-4 991:col-span-2 text-right",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: props.year
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                        ]
                    })
                ]
            })
        })
    });
};
var NewsCard = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "card ".concat(props.size == "Large" ? "1024:col-span-8 col-span-12" : "1024:col-span-4 col-span-12"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "image-container",
                children: props.videoDesktop && props.videoMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoLazy, {
                    videoDesktop: props.videoDesktop,
                    videoMobile: props.videoMobile
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageWithTransition/* default */.Z, {
                    src: props.imageUrl,
                    layout: "fill",
                    alt: ""
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-2 leading-6 uppercase project-info text-16 768:text-18 1280:text-22",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    children: props.title
                })
            })
        ]
    });
};


/***/ }),

/***/ 3678:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ Home; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var components_MetaTags__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8992);
/* harmony import */ var components_Elements_Container__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4721);
/* harmony import */ var components_GridCards__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6980);
/* harmony import */ var components_Elements_ButtonTicker__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4);
/* harmony import */ var components_Elements_AnimatedBox__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7603);
/* harmony import */ var strapi_api__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1014);
/* harmony import */ var components_Elements_ImageGlliph__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4318);








var __N_SSG = true;
function Home(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_MetaTags__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                title: props.meta_info && props.meta_info.meta_title ? props.meta_info.meta_title : "An Independent Animation Studio",
                description: props.meta_info && props.meta_info.meta_description ? props.meta_info.meta_description : "ZANAD | An Independent Animation Studio",
                image: props.meta_info && props.meta_info.og_image ? strapi_api__WEBPACK_IMPORTED_MODULE_7__/* ["default"].getNextImage */ .Z.getNextImage(props.meta_info.og_image, "large") : "/public/og-image.jpg"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("main", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                        className: "offscreen-title",
                        children: props.meta_info && props.meta_info.meta_title ? props.meta_info.meta_title : "ZANAD | An Independent Animation Studio"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_Elements_Container__WEBPACK_IMPORTED_MODULE_2__/* .ContainerHomepage */ .rB, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                className: "mb-6 uppercase fluid-type",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_AnimatedBox__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                        num: 1,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "flex flex-row justify-start",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                className: "optical-align letter-b",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_AnimatedBox__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                        num: 3.5,
                                                        children: "Bad"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_AnimatedBox__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                        num: 1,
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_ImageGlliph__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                                            src: "MARGIN_BOLT"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_AnimatedBox__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                        num: 7,
                                                        children: "ideas "
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_AnimatedBox__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                        num: 2.5,
                                                        children: "die"
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_AnimatedBox__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                        num: 2,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                            className: "flex flex-row justify-between",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_AnimatedBox__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                    num: 5.5,
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        children: "young."
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                            className: "block 640:hidden",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {})
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_AnimatedBox__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                            num: 1.5,
                                                            children: "We "
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_AnimatedBox__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                            num: 3.5,
                                                            children: "make"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_AnimatedBox__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                        num: 3,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "flex flex-row justify-end",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_AnimatedBox__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                        num: 3,
                                                        children: "them"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_AnimatedBox__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                        num: 6,
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_ImageGlliph__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                                            src: "MARGIN_SKULL"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_AnimatedBox__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                        num: 1.5,
                                                        children: "immortal."
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "relative gap-x-5 gap-y-8 grid grid-cols-12",
                                children: props.content.homepage_work ? props.content.homepage_work.map(function(work, i) {
                                    return work.url || work.outside_url ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_GridCards__WEBPACK_IMPORTED_MODULE_3__/* .ProjectCard */ .t, {
                                        imageUrl: strapi_api__WEBPACK_IMPORTED_MODULE_7__/* ["default"].getNextImage */ .Z.getNextImage(work.image, "large"),
                                        title: work.project_title,
                                        client: work.client,
                                        year: work.year,
                                        projectLink: work.url,
                                        outsideURL: work.outside_url,
                                        index: i,
                                        videoDesktop: work.video_large,
                                        videoMobile: work.video_small,
                                        size: work.size
                                    }, i) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_GridCards__WEBPACK_IMPORTED_MODULE_3__/* .NewsCard */ .e, {
                                        imageUrl: strapi_api__WEBPACK_IMPORTED_MODULE_7__/* ["default"].getNextImage */ .Z.getNextImage(work.image, "large"),
                                        title: work.project_title,
                                        index: 6,
                                        videoDesktop: work.video_large,
                                        videoMobile: work.video_small,
                                        size: work.size
                                    }, i);
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {})
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                className: "mt-8 mb-6 uppercase fluid-type",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "flex flex-row justify-start",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_AnimatedBox__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                    num: 1,
                                                    children: "The "
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_AnimatedBox__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                    num: 5.5,
                                                    children: "international"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "flex flex-row justify-end",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_AnimatedBox__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                    num: 3,
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_ImageGlliph__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                                        src: "MARGIN_GLOBE"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_AnimatedBox__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                    num: 6,
                                                    children: "independent "
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_AnimatedBox__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                    num: 1.5,
                                                    children: "animation"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                        className: "flex flex-row justify-start",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: "inline-block optical-align letter-s",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_AnimatedBox__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                    num: 3.5,
                                                    children: "studio"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: "inline-block",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_AnimatedBox__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                    num: 6.6,
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_ButtonTicker__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                        title: "About Us",
                                                        url: "/about",
                                                        external: false
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_AnimatedBox__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                        num: 2,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "flex flex-row justify-end",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_AnimatedBox__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                        num: 6.5,
                                                        children: "that "
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_AnimatedBox__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                        num: 5,
                                                        children: "ignites"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_AnimatedBox__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                        num: 1.5,
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_ImageGlliph__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                                            src: "MARGIN_WIZARD"
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_AnimatedBox__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                        num: 2,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "flex flex-row justify-start",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                className: "optical-align letter-b",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_AnimatedBox__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                        num: 2.5,
                                                        children: "untamed "
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_AnimatedBox__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                        num: 7,
                                                        children: "ideas "
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_AnimatedBox__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                        num: 3,
                                                        children: "globally."
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [675,608,84,774,888,179], function() { return __webpack_exec__(5557); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);